import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  calendarHeader: {
    width: 129,
    height: 12,
    alignSelf: 'center',
    marginBottom: 4,
    marginTop: 15
  },
  calendarWeeks: {
    width: '100%',
    alignSelf: 'center',
    marginTop: 21,
    height: 12
  },
  availableSlots: {
    width: 129,
    height: 12,
    alignSelf: 'center',
    marginBottom: 9,
    marginTop: 44
  },
  selectedDate: {
    width: 202,
    height: 12,
    alignSelf: 'center',
    marginBottom: 32
  },
  timeSlotContainer: {
    marginHorizontal: -7,
    marginVertical: 9,
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  timeSlot: theme => ({
    width: '33.3%',
    height: 30,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: theme.colors.borderColorTwo
  }),
  divider: {
    width: '100%',
    height: 1,
    marginTop: 16
  },
  button: {
    width: '100%',
    height: 28,
    marginTop: 24
  }
})
